/* Bogart Engineering Theme JS v1.0.0 */
document.addEventListener('DOMContentLoaded',function(){
  // Accordion
  document.querySelectorAll('.accordion-header').forEach(function(h){
    h.addEventListener('click',function(){
      var body=this.nextElementSibling,arrow=this.querySelector('.acc-arrow'),isOpen=body.classList.contains('open');
      var acc=this.closest('.accordion');
      acc.querySelectorAll('.accordion-body').forEach(function(b){b.classList.remove('open')});
      acc.querySelectorAll('.acc-arrow').forEach(function(a){a.textContent='+'});
      if(!isOpen){body.classList.add('open');if(arrow)arrow.textContent='−'}
    });
  });
  // Gallery thumbs
  var thumbs=document.querySelectorAll('.gallery-thumb'),mainImg=document.querySelector('.gallery-main-img');
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      thumbs.forEach(function(x){x.classList.remove('active')});
      this.classList.add('active');
      if(mainImg&&this.dataset.src)mainImg.src=this.dataset.src;
    });
  });
  // ── VARIANT SELECTOR ──
  var variantData = null;
  var variantJsonEl = document.getElementById('product-variants-json');
  if (variantJsonEl) {
    try { variantData = JSON.parse(variantJsonEl.textContent); } catch(e) {}
  }

  // Track currently selected options (1-indexed to match Shopify)
  var selectedOptions = {};
  document.querySelectorAll('.variant-btns').forEach(function(group) {
    var idx = group.dataset.optionIndex;
    var active = group.querySelector('.variant-btn.active');
    if (active) selectedOptions[idx] = active.dataset.optionValue;
  });

  function findVariant() {
    if (!variantData) return null;
    return variantData.find(function(v) {
      return Object.keys(selectedOptions).every(function(idx) {
        var key = 'option' + idx;
        return v[key] === selectedOptions[idx];
      });
    }) || null;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateProductUI(variant) {
    if (!variant) return;

    // Update hidden input
    var idInput = document.getElementById('variant-id');
    if (idInput) idInput.value = variant.id;

    // Update price
    var priceEl = document.getElementById('variant-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update compare price & savings
    var compareEl = document.getElementById('variant-compare');
    var saveEl    = document.getElementById('variant-save');
    if (compareEl && saveEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
        saveEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
        saveEl.style.display    = 'none';
      }
    }

    // Update Add to Cart button
    var atcBtn = document.getElementById('atc-btn');
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled    = false;
        atcBtn.textContent = 'Add to Cart — ' + formatMoney(variant.price) + ' →';
      } else {
        atcBtn.disabled    = true;
        atcBtn.textContent = 'Out of Stock';
      }
    }
  }

  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx   = this.dataset.optionIndex;
      var value = this.dataset.optionValue;

      // Update selected state for this option group
      var group = document.querySelector('.variant-btns[data-option-index="' + idx + '"]');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
      }
      this.classList.add('active');
      selectedOptions[idx] = value;

      // Update the label to show selected value
      var labelVal = document.getElementById('selected-' + idx);
      if (labelVal) labelVal.textContent = value;

      // Find matching variant and update UI
      var matched = findVariant();
      updateProductUI(matched);
    });
  });
  // Homepage tab filter
  var tabBtns=document.querySelectorAll('.tab-btn');
  tabBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      tabBtns.forEach(function(b){b.classList.remove('active')});
      this.classList.add('active');
      var f=this.dataset.filter;
      document.querySelectorAll('.product-card[data-category]').forEach(function(c){
        c.style.display=(f==='all'||c.dataset.category===f)?'':'none';
      });
    });
  });
  // Filter tabs (collection page) — filters visible cards on current page only
  var filterTabs=document.querySelectorAll('.filter-tab');
  filterTabs.forEach(function(t){
    t.addEventListener('click',function(){
      filterTabs.forEach(function(x){x.classList.remove('active')});
      this.classList.add('active');
      var f=this.dataset.filter;
      var cards=document.querySelectorAll('.products-grid .product-card[data-category]');
      var anyVisible=false;
      cards.forEach(function(c){
        var show=(f==='all'||c.dataset.category===f);
        c.style.display=show?'':'none';
        if(show)anyVisible=true;
      });
      // Show empty state if no cards match
      var emptyMsg=document.querySelector('.products-grid .no-filter-results');
      if(!anyVisible&&!emptyMsg){
        var msg=document.createElement('p');
        msg.className='no-filter-results';
        msg.style='grid-column:1/-1;text-align:center;color:var(--muted);padding:40px 0';
        msg.textContent='No products in this category.';
        document.querySelector('.products-grid').appendChild(msg);
      } else if(anyVisible&&emptyMsg){
        emptyMsg.remove();
      }
    });
  });
  // Qty buttons — product page only (cart uses inline onclicks)
  document.querySelectorAll('.add-to-cart-section .qty-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var input=this.closest('.add-to-cart-section').querySelector('input[name="quantity"]');
      if(!input)return;
      var v=parseInt(input.value)||1;
      if(this.dataset.action==='minus')v=Math.max(1,v-1);
      else v=v+1;
      input.value=v;
    });
  });
  // Sticky header shadow
  var header=document.querySelector('.site-header');
  if(header){window.addEventListener('scroll',function(){header.style.boxShadow=window.scrollY>10?'0 4px 20px rgba(0,0,0,.2)':'0 2px 12px rgba(0,0,0,.15)';});}
});
